export default "__VITE_ASSET__67642e4b__"